import {DateHelper} from '@/shared/utils';

export default (timestamp: number): string => {
	const date = new Date();
	date.setTime(timestamp);
	return DateHelper.toDisplayDate(date);
};